import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { EnumUtils } from '@macs-frontend/web-macs/shared/utils/enum';

@Pipe({ name: 'enumValuesToArray' })
export class EnumValuesToArrayPipe implements PipeTransform {
  @memoize()
  public transform<T extends Record<string | symbol | number, unknown>>(
    enumObj: T,
    valuesAreNumbers: boolean = false,
  ): T[keyof T][] {
    return EnumUtils.valuesToArray(enumObj, valuesAreNumbers) as unknown as T[keyof T][];
  }
}
